import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/awesome-design-system-2/awesome-design-system-2/node_modules/@bridgetool/gatsby-theme-dev/src/components/ThemeComponents/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Well-defined typography styles in combination with a design system layout grid will create structured content.`}</p>
    <h2>{`Base`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-html",
        "metastring": "live",
        "live": true
      }}>{`<p>The base type is 1.6rem (16px) over 1.6 line height (24px)</p>
`}</code></pre>
    <h2>{`Headings`}</h2>
    <p>{`Headings are made with styles for `}<inlineCode parentName="p">{`<h1>`}</inlineCode>{` through `}<inlineCode parentName="p">{`<h6>`}</inlineCode>{` tags.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html",
        "metastring": "live",
        "live": true
      }}>{`<h1>Heading 1</h1>
<h2>Heading 2</h2>
<h3>Heading 3</h3>
<h4>Heading 4</h4>
<h5>Heading 5</h5>
<h6>Heading 6</h6>
`}</code></pre>
    <h2>{`Text elements`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-html",
        "metastring": "live",
        "live": true
      }}>{`<a>Anchor</a><br />
<em>Emphasis</em><br />
<small>Small</small><br />
<strong>Strong</strong><br />
<u>Underline</u>
`}</code></pre>
    <h2>{`How this page is built`}</h2>
    <p>{`To make the typography examples working, we had to provide global styles for all the exmaples. It can be done
in `}<inlineCode parentName="p">{`src/@bridgetool/gatsby-theme-dev/components/live-preview-wrapper.js`}</inlineCode>{` file.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React from "react"
import milligramStyles from "!!raw-loader!milligram/dist/milligram.css"
import { Frame } from "@bridgetool/gatsby-theme-dev"

function LivePreviewWrapper({ children }) {
  return (
    <Frame>
      <style>{milligramStyles}</style>
      <div>{children}</div>
    </Frame>
  )
}

export default LivePreviewWrapper
`}</code></pre>
    <p>{`Use `}<inlineCode parentName="p">{`raw-loader`}</inlineCode>{` to get the content of your CSS file and output it in `}<inlineCode parentName="p">{`<style>`}</inlineCode>{` tag
inside `}<inlineCode parentName="p">{`<Frame>`}</inlineCode>{`. This way, you can provide any global CSS, and it will only
apply to the examples not to the documentation pages.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      